import { API_BASE_URL } from "./config";

const DEFAULT_TIMEOUT = 60000;

async function fetchWithTimeout(url, options = {}, timeout = DEFAULT_TIMEOUT) {

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {

        const response = await fetch(url, {
            ...options,
            signal: controller.signal
        });

        clearTimeout(id);
        return response;

    } catch (error) {

        clearTimeout(id);
        throw error;
    }
}

export async function postJson(path, payload, extraHeaders = {}) {

    const url = `${API_BASE_URL}${path}`;

    const response = await fetchWithTimeout(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...extraHeaders
        },
        body: JSON.stringify(payload)
    });

    let data;

    try {
        data = await response.json();
    } catch {
        data = null;
    }

    if (!response.ok) {
        throw new Error(data?.message || "Request failed");
    }

    return data;
}
